/* tslint:disable */

declare var Object: any;
export interface SFLeaveRequestSF6Interface {
  "id"?: number;
}

export class SFLeaveRequestSF6 implements SFLeaveRequestSF6Interface {
  "id": number;
  constructor(data?: SFLeaveRequestSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLeaveRequestSF6`.
   */
  public static getModelName() {
    return "SFLeaveRequestSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLeaveRequestSF6 for dynamic purposes.
  **/
  public static factory(data: SFLeaveRequestSF6Interface): SFLeaveRequestSF6{
    return new SFLeaveRequestSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLeaveRequestSF6',
      plural: 'SFLeaveRequestSF6s',
      path: 'SFLeaveRequestSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLeaveRequestSF6.ts